import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Document\Editor\StoreDocumentEditorController::__invoke
* @see app/Http/Controllers/Document/Editor/StoreDocumentEditorController.php
* @route '/api/editor/{type}'
*/
const StoreDocumentEditorController = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: StoreDocumentEditorController.url(args, options),
    method: 'post',
})

StoreDocumentEditorController.definition = {
    methods: ["post"],
    url: '/api/editor/{type}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Document\Editor\StoreDocumentEditorController::__invoke
* @see app/Http/Controllers/Document/Editor/StoreDocumentEditorController.php
* @route '/api/editor/{type}'
*/
StoreDocumentEditorController.url = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { type: args }
    }

    if (Array.isArray(args)) {
        args = {
            type: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        type: args.type,
    }

    return StoreDocumentEditorController.definition.url
            .replace('{type}', parsedArgs.type.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Document\Editor\StoreDocumentEditorController::__invoke
* @see app/Http/Controllers/Document/Editor/StoreDocumentEditorController.php
* @route '/api/editor/{type}'
*/
StoreDocumentEditorController.post = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: StoreDocumentEditorController.url(args, options),
    method: 'post',
})

export default StoreDocumentEditorController